export enum DataLoadingStates {
    LOADING = 'loading',
    SUCCESS = 'success',
    ERROR = 'error',
    INITIAL = 'initial',
}

export enum HLDataLoadingStates {
    PENDING = 'pending',
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum DATA_TYPES {
    SIZE = 'size',
    PNL = 'pnl',
}

export enum TABLE_INTERACTION_TYPES {
    PAGINATION = 'pagination',
    SORT = 'sort',
    SEARCH = 'search',
}

export enum ROWS_ON_PAGE {
    TEN = '10',
    TWENTY = '20',
    FIFTY = '50',
    HUNDRED = '100',
    FIVE_HUNDRED = '500',
}

export enum RANGE_TYPES {
    DAY = '24h',
    WEEK = '7d',
    MONTH = '30d',
    ALL = 'all',
}

export enum USAGE_RANGE {
    THIS_MONTH = 'this_month',
    JANUARY = 'january',
    FEBRUARY = 'february',
    MARCH = 'march',
    APRIL = 'april',
    MAY = 'may',
    JUNE = 'june',
    JULY = 'july',
    AUGUST = 'august',
    SEPTEMBER = 'september',
    OCTOBER = 'october',
    NOVEMBER = 'november',
    DECEMBER = 'december',
}

export enum BUILDER_CHART_VIEW_TYPES {
    PERFORMANCE = 'performance',
    TOTAL_REVENUE = 'totalRevenue',
}

export enum MODAL_TYPE_HANDLER {
    IS_TWITTER_DETAIL = 'isTwitterDetail',
    IS_DISPLAY_X_ACCOUNT = 'isDisplayXAccount',
    IS_CLAIM_WALLET = 'isClaimWallet',
    IS_OPEN_CONNECT_MODAL = 'isOpenConnectModal',
    IS_TABLE_INTERACTION_MODAL = 'isTableInteractionModal',
    IS_AUTH_MODAL = 'isAuthModal',
    IS_ADDING_KEY_MODAL = 'isAddingKeyModal',
    IS_EDIT_KEY_MODAL = 'isEditKeyModal',
    IS_EDIT_PRIVATE_LABEL_MODAL = 'isEditPrivateLabelModal',
    IS_LOGIN_TO_ADD_FAVORITES = 'isLoginToAddFavorites',
    IS_REMOVE_FROM_FAVORITES = 'isRemoveFromFavorites',
    IS_EDIT_DISPLAY_NAME_MODAL = 'isEditDisplayNameModal',
    IS_MAX_FAVORITES_REACHED_VARIANT_1 = 'isMaxFavoritesReachedVariant1',
    IS_MAX_FAVORITES_REACHED_VARIANT_2 = 'isMaxFavoritesReachedVariant2',
    IS_VAULT_INFO_MODAL = 'isVaultInfoModal',
    IS_TRY_PERPS_SORTING_MODAL = 'isTryPerpsSortingModal',
    IS_TRY_PERPS_FILTERING_MODAL = 'isTryPerpsFilteringModal',
    IS_CLAIM_BUILDER_MODAL = 'isClaimBuilderModal',
    IS_UNLOCK_BUILDER_MODAL = 'isUnlockBuilderModal',
    IS_ADD_WALLET_TO_FAVORITE = 'isAddWalletToFavorites',
    IS_ADD_ALERT_UNLOGGED_RESTRICTION = 'isAddAlertFromWallet',
    IS_ADD_ALERT_MODAL = 'isAddAlertModal',
    IS_ADD_WEBHOOK_MODAL = 'isAddWebhookModal',
    IS_CONNECTIONS_BASED_MODAL = 'isConnectionsBasedModal',
    IS_TRADE_SNAPSHOT_MODAL = 'isTradeSnapshotModal',
    IS_CONNECTIONS_HL_REF_MODAL = 'isConnectionsHLRefModal',
    IS_HOW_MARKET_RADAR_WORKS_MODAL = 'isHowMarketRadarWorksModal',
    IS_UNLOCK_LIQUIDATIONS_DATA_MODAL = 'isUnlockLiquidationsDataModal',
    IS_ALPHAFEED_CONNECT_WALLET_MODAL = 'isAlphafeedConnectWalletModal',
    IS_ALPHAFEED_TRADING_SETUP_MODAL = 'isAlphafeedTradingSetupModal',
    IS_ALPHAFEED_ONBOARDING_MODAL = 'isAlphafeedOnboardingModal',
}

export enum SEGMENTS {
    LEVIATHAN = 'segments_labels.leviathan',
    TIDAL_WHALE = 'segments_labels.tidal_whale',
    WHALE = 'segments_labels.whale',
    SMALL_WHALE = 'segments_labels.small_whale',
    APEX_PREDATOR = 'segments_labels.apex_predator',
    DOLPHIN = 'segments_labels.dolphin',
    FISH = 'segments_labels.fish',
    SHRIMP = 'segments_labels.shrimp',
    MONEY_PRINTER = 'segments_labels.money_printer',
    SMART_MONEY = 'segments_labels.smart_money',
    GRINDER = 'segments_labels.consistent_grinder',
    HUMBLE_EARNER = 'segments_labels.humble_earner',
    EXIT_LIQUIDATION = 'segments_labels.exit_liquidity',
    SEMI_REKT = 'segments_labels.semi_rekt',
    FULL_REKT = 'segments_labels.full_rekt',
    GIGA_RECT = 'segments_labels.giga_rekt',
}

export enum SEGMENTS_CRITERIA {
    LEVIATHAN = 'segments_criteria_labels.leviathan',
    TIDAL_WHALE = 'segments_criteria_labels.tidal_whale',
    WHALE = 'segments_criteria_labels.whale',
    SMALL_WHALE = 'segments_criteria_labels.small_whale',
    APEX_PREDATOR = 'segments_criteria_labels.apex_predator',
    DOLPHIN = 'segments_criteria_labels.dolphin',
    FISH = 'segments_criteria_labels.fish',
    SHRIMP = 'segments_criteria_labels.shrimp',
    MONEY_PRINTER = 'segments_criteria_labels.money_printer',
    SMART_MONEY = 'segments_criteria_labels.smart_money',
    GRINDER = 'segments_criteria_labels.consistent_grinder',
    HUMBLE_EARNER = 'segments_criteria_labels.humble_earner',
    EXIT_LIQUIDATION = 'segments_criteria_labels.exit_liquidity',
    SEMI_REKT = 'segments_criteria_labels.semi_rekt',
    FULL_REKT = 'segments_criteria_labels.full_rekt',
    GIGA_RECT = 'segments_criteria_labels.giga_rekt',
}

export enum SEGMENTS_SIMPLIFIED_CRITERIA {
    LEVIATHAN = 'segments_simplified_criteria_labels.leviathan',
    TIDAL_WHALE = 'segments_simplified_criteria_labels.tidal_whale',
    WHALE = 'segments_simplified_criteria_labels.whale',
    SMALL_WHALE = 'segments_simplified_criteria_labels.small_whale',
    APEX_PREDATOR = 'segments_simplified_criteria_labels.apex_predator',
    DOLPHIN = 'segments_simplified_criteria_labels.dolphin',
    FISH = 'segments_simplified_criteria_labels.fish',
    SHRIMP = 'segments_simplified_criteria_labels.shrimp',
    MONEY_PRINTER = 'segments_simplified_criteria_labels.money_printer',
    SMART_MONEY = 'segments_simplified_criteria_labels.smart_money',
    GRINDER = 'segments_simplified_criteria_labels.consistent_grinder',
    HUMBLE_EARNER = 'segments_simplified_criteria_labels.humble_earner',
    EXIT_LIQUIDATION = 'segments_simplified_criteria_labels.exit_liquidity',
    SEMI_REKT = 'segments_simplified_criteria_labels.semi_rekt',
    FULL_REKT = 'segments_simplified_criteria_labels.full_rekt',
    GIGA_RECT = 'segments_simplified_criteria_labels.giga_rekt',
}

export interface PerpsPosition {
    amount: number;
    avgEntry: number;
    digits: number;
    direction: string;
    distToLiq: number;
    funding: number;
    liquidationPrice: number;
    livePrice: number;
    pnl: number;
    token: string;
    value: number;
    leverage: number;
    type: string;
    returnOnEquity: number;
    favorite?: boolean;
    id?: string | number;
    openTime?: string | number | null;
}

export interface Holdings {
    token: string;
    balance: number;
    livePrice: number;
    allocation: number;
    value: number;
}

export interface SelectOption<V = string> {
    label: string;
    minSize?: number;
    maxSize?: number;
    wallets?: number;
    isPnl?: boolean;
    value: V;
}

export enum SegmentId {
    Shrimp = 16,
    Fish = 1,
    Dolphin = 2,
    ApexPredator = 3,
    SmallWhale = 4,
    Whale = 5,
    TidalWhale = 6,
    Leviathan = 7,
    MoneyPrinter = 8,
    SmartMoney = 9,
    ConsistentGrinder = 10,
    HumbleEarner = 11,
    ExitLiquidity = 12,
    SemiRekt = 13,
    FullRekt = 14,
    GigaRekt = 15,
}

export const sizeSegments = [
    SegmentId.Leviathan,
    SegmentId.TidalWhale,
    SegmentId.Whale,
    SegmentId.SmallWhale,
    SegmentId.ApexPredator,
    SegmentId.Dolphin,
    SegmentId.Fish,
    SegmentId.Shrimp,
];

export const pnlSegments = [
    SegmentId.MoneyPrinter,
    SegmentId.SmartMoney,
    SegmentId.ConsistentGrinder,
    SegmentId.HumbleEarner,
    SegmentId.ExitLiquidity,
    SegmentId.SemiRekt,
    SegmentId.FullRekt,
    SegmentId.GigaRekt,
];

export interface HoldingsItem {
    allocation: number;
    balance: number;
    livePrice: number;
    token: string;
    value: number;
}
export interface OpenOrdersItem {
    coin: string;
    size: number;
    side: string;
    orderType: string;
    triggerPrice: number;
    timestamp: number;
    isPositionTpsl: boolean;
    cloid: string;
}

export interface OutcomeSideSpec {
    name: string;
}

export interface OutcomeMetaEntry {
    outcome: number;
    name: string;
    description: string;
    sideSpecs: OutcomeSideSpec[];
}

export interface OutcomeQuestionEntry {
    question: number;
    name: string;
    description: string;
    fallbackOutcome: number;
    namedOutcomes: number[];
    settledNamedOutcomes: number[];
}

export interface OutcomeMeta {
    outcomes: OutcomeMetaEntry[];
    questions: OutcomeQuestionEntry[];
}

export interface OutcomePosition {
    id: string;
    coin: string;
    label: string;
    direction: 'YES' | 'NO';
    size: number;
    value: number;
    avgEntry: number;
    livePrice: number;
    pnl: number;
    openTime: string | number | null;
}

export interface OutcomesSummary {
    yesValue: number;
    noValue: number;
    totalValue: number;
    sumPnl: number;
}

export interface PerpsBias {
    longs: number;
    progressFill: number;
    shorts: number;
    netBias: number;
    exposureRatio: number;
    finalBias: number;
}

export interface Web2Data {
    holdingsList: HoldingsItem[];
    perpsBias: PerpsBias;
    perpsList: PerpsPosition[];
    totalEquity: number;
    spot: number;
    vault: number;
    perps: number;
    staked: number;
    dex: number;
    outcomesList: OutcomePosition[];
    outcomesSummary: OutcomesSummary;
    isLoading: boolean;
}

export enum LANGUAGES {
    EN = 'en',
    RU = 'ru',
    UK = 'uk',
    // KO = 'ko',
    // JA = 'ja',
    // ZH = 'zh',
}

export interface PerpsChartPeriod {
    accountValueHistory: (number | string)[][];
    pnlHistory: (number | string)[][];
    vlm: string;
}

export type PerpsChart = Record<string, PerpsChartPeriod>;

export interface PnlStats {
    day: number;
    week: number;
    month: number;
    allTime: number;
}

export interface SubAccount {
    subAccountUser: string;
    name: string;
    master: string;
    totalEquity: number;
    openValue: number;
    sumUpnl: number;
}

export interface ReferralsTableData {
    timeJoined: number;
    user: string;
    totalFeesPaid: number;
    referrerShare: number;
    referrerSharePercentage: number;
    totalVolume: number;
}

export interface ReferralsSummaryData {
    refCode: string;
    totalReferrals: number;
    referredBy: string;
    totalEarnings: number;
    referralRewards: number;
    builderRewards: number;
    volumeGenerated: number;
}

export interface TransfersData {
    sourceDex: string;
    time: number;
    type: string;
    usdc: number;
    amount: number;
    value: number;
    hash: string;
    destination: string;
    destinationDex: string;
    user: string;
    token: string;
    vault: string;
    toPerp: boolean;
    isDeposit: boolean;
    nonce: number;
}
export interface FillLiquidation {
    liquidatedUser?: string;
    markPx?: string;
    method?: string;
}

export interface RecentFeelsItem {
    closedPnl: number;
    coin: string;
    crossed: boolean;
    dir: string;
    fee: number;
    feeToken: string;
    hash: string;
    oid: number;
    px: number;
    side: string;
    startPosition: number;
    sz: number;
    tid: number;
    time: number;
    twapId: string | number | null;
    liquidation: string | number | FillLiquidation;
    notionalValue: number;
    count: number;
    digits: number;
}

export interface SocketData {
    web2Data: Web2Data;
    totalPnl: number;
    loadingSocket: string;
    perpsChart: PerpsChart;
    overallPnl: number;
    pnlStats: PnlStats;
    overallPnlStats: PnlStats;
    pnlStatus: HLDataLoadingStates;
    vaultData: any;
    vaultDataStatus: HLDataLoadingStates;
    subAccMaster: string;
    subAccMasterData: {
        totalEquity: number | null;
        sumUpnl: number | null;
        openValue: number | null;
    };
    subAccountData: SubAccount[];
    subAccountsDataStatus: HLDataLoadingStates;
    referralsData: {
        tableReferralsData: ReferralsTableData[];
        summaryReferralsData: ReferralsSummaryData;
    };
    referralsDataStatus: HLDataLoadingStates;
    transfersData: TransfersData[];
    transfersDataStatus: HLDataLoadingStates;
    isTransfersCapped: boolean;
    openOrdersData: OpenOrdersItem[];
    openOrdersDataStatus: HLDataLoadingStates;
    recentFillsData: RecentFeelsItem[];
    recentFillsDataStatus: HLDataLoadingStates;
    earliestActivity: number | null;
    livePrices?: any;
}

export interface SegmentsData {
    perpVolume24HoursAgo: number;
    perpVolume: number;
    countTraders: number;
    lastUpdate: string;
    nextUpdate: string;
    perpPositionsMetrics: {
        count: number;
        openInterest: number;
    };
    perpPositionsMetricsHourAgo: {
        count: number;
        openInterest: number;
    };
    perpPositionsMetrics24HoursAgo: {
        count: number;
        openInterest: number;
    };
    segments: HomeSegmentData[];
    segments24h: HomeSegmentByAge[];
    segments7d: HomeSegmentByAge[];
    segments30d: HomeSegmentByAge[];
    countActiveTraders: number;
    countTraders24HoursAgo: number;
}

/** isMarginSwitch marks the point where bias switches to perp margin equity (BE-858). */
export type BiasMetricPoint = [timestamp: string, bias: number, isMarginSwitch?: boolean];

export interface SegmentsBiasMetrics {
    [key: number]: BiasMetricPoint[];
}

export interface SegmentCriteria {
    minSize?: number;
    maxSize?: number;
    minPnl?: number;
    maxPnl?: number;
}

export interface HomeSegment {
    id: number;
    name: string;
    category: DATA_TYPES;
    criteria: SegmentCriteria;
}

interface SegmentMarginValues {
    activePerpMarginEquity: number;
    marginPerpBias: number;
    marginExposureRatio: number;
}

export interface HomeSegmentData extends SegmentMarginValues {
    perpEquity: number;
    perpMarginEquity: number;
    activePerpEquity: number;
    countTraders: number;
    countTradersInPosition: number;
    perpBias: number;
    segment: HomeSegment;
    exposureRatio: number;
    perpPnl: number;
    positionLongValue: number;
    positionShortValue: number;
    positionValue: number;
}

export interface HomeSegmentByAge extends SegmentMarginValues {
    activePerpEquity: number;
    countTradersInPosition: number;
    exposureRatio: number;
    perpBias: number;
    positionLongValue: number;
    positionShortValue: number;
    positionValue: number;
    segmentId: number;
}

export interface HomeCardData {
    categoryTitle: string;
    perpBias: number;
    wallets: number;
    inPosition: number;
    id: number;
    exposureRatio: number;
    biasMetrics: BiasMetricPoint[];
    criteria?: SegmentCriteria;
    biasPercentage?: number;
    activePerpEquity: number;
    perpEquity: number;
    openValue: number;
    countTradersInPosition: number;
}

export interface PerpsPageHeaderData {
    countTraders: number;
    segment: HomeSegment;
    openPerpsSummary: OpenPositionSummary;
    lastUpdate: string;
    history: { columns: string[]; data: (string | number)[][] };
    tradersCount24HoursAgo: number;
    biasHistory: { date: string; value: number }[];
}

export interface OpenPositionBySide {
    side: 'long' | 'short';
    countOpenPositions: number;
    totalSize: number;
    totalValue: number;
}

export interface OpenPositionSummary {
    countOpenPositions: number;
    totalSize: number;
    totalValue: number;
    countTradersInPosition: number;
    countTradersInProfit: number;
    bySide: OpenPositionBySide[];
    perpBias?: number;
}

export interface TopOpenPerp {
    coin: string;
    totalValue: number;
    totalValueLong: number;
    totalValueShort: number;
    count: number;
    countLong: number;
    countShort: number;
    rank?: number;
}

export interface LiquidationRiskByAsset {
    coin: string;
    totalValue: number;
    riskValue: number;
    percentRisk: number;
}

export interface ShowName {
    text: string | null;
    emoji: string | null;
}

export interface Profile {
    address: string;
    countOpenPositions: number;
    pnl: number;
    balance: number;
    segments: number[];
    totalEquity: number;
    perpEquity: number;
    perpMarginEquity: number;
    emoji: string | null;
    displayName: string | null;
    showName?: ShowName | null;
    verified: boolean;
    xUserId?: string | null;
}

export interface LargestPosition {
    value: number;
    size: number;
    coin: string;
    profile: Profile;
    openTime: string;
}

export interface SegmentData extends PerpsPageHeaderData {
    top10OpenPerps: TopOpenPerp[];
    liquidationRiskByAsset: LiquidationRiskByAsset[];
    largestPositions: LargestPosition[];
}

export interface ClosestLiq {
    coin: string;
    progress: number;
}

export interface WalletListItem {
    segments: number[];
    address: string;
    totalEquity: number;
    perpEquity: number;
    perpMarginEquity?: number;
    perpBias: number;
    openValue: number;
    sumUpnl: number;
    closestLiq: ClosestLiq;
}

export interface xUserType {
    name: string;
    profileImageUrl: string;
    screenName: string;
    verified: boolean;
    xUserId: string;
    followersCount: number;
    followingCount?: number;
}

export interface FavoritePositions {
    address: string;
    closeTime: string | number | null;
    coin: string;
    crossLeverage: number;
    dex: string;
    digits: number;
    entryPrice: number;
    favorite: {
        favorite?: boolean;
        featured?: boolean;
        emoji?: string | null;
        displayName?: string | null;
    };
    funding: number;
    id: string;
    isolatedLeverage: number;
    liquidationPrice: number;
    liquidationProgress: number;
    markPrice: number;
    midPrice: number;
    openTime: string;
    premiumPrice: number;
    profile: Profile;
    side: 'long' | 'short';
    size: number;
    unrealizedPnl: number;
    value: number;
}

export interface Positions {
    address: string;
    coin: string;
    crossLeverage: number;
    entryPrice: number;
    funding: number;
    isolatedLeverage: number;
    liquidationPrice: number;
    markPrice: number;
    midPrice: number;
    premiumPrice: number;
    segmentId: number;
    side: 'long' | 'short';
    size: number;
    unrealizedPnl: number;
    value: number;
    liquidationProgress: number;
    openTime?: string;
    profile?: Profile;
    favorite?: boolean;
    id?: string;
    closeTime?: string | number | null;
}

export interface CoinAnalytic {
    coin: string;
    count: number;
    countLong: number;
    countShort: number;
    segmentId: number;
    positions?: Positions[];
    totalValue: number;
    totalValueLong: number;
    totalValueShort: number;
}

export type SegmentsType = {
    [key in SegmentId]?: any;
};

export interface HeatmapRowType {
    coin: string;
    count: number;
    countLong: number;
    countShort: number;
    totalValue: number;
    totalValueLong: number;
    totalValueShort: number;
    segments: SegmentsType;
}

export interface HeatmapDataItem extends Omit<HeatmapRowType, 'segments'> {
    segments?: CoinAnalytic[];
}

export type HeatmapData = HeatmapDataItem[];

export interface HeatmapDataResponse {
    heatmap: HeatmapData;
    totalPositionsCount: number;
    positionsCountsByFilter: number;
}

export interface FavoriteAccount {
    favoriteCount?: number;
    address: string;
    displayName: string | null;
    showName?: ShowName | null;
    emoji: string | null;
    featured: boolean;
}

export interface FavoriteLimits {
    minPerpMonthVolume: number;
    perpMonthVolume: number;
    countFavorites: number;
    unlockedAccounts: number;
    totalAccounts: number;
    maxFavorites: number;
}

export interface SSETokenResponse {
    token: string;
    expiresInSeconds: number;
}

export interface SearchWalletResult {
    address: string;
}

export interface SearchRefCodeResult {
    refCode: string;
    address: string;
}

export interface SearchUsernameResult {
    username: string;
    address: string;
}

export interface SearchTwitterResult {
    screenName: string;
    address: string;
}

export interface SearchBuilderResult {
    name: string;
    address: string;
}

export interface SearchHlNameResult {
    hlName: string;
    address: string;
}

export interface SearchHyperliquidNameResult {
    displayName: string;
    address: string;
}

export interface UnifiedSearchResponse {
    wallets: SearchWalletResult[];
    refCodes: SearchRefCodeResult[];
    usernames: SearchUsernameResult[];
    twitter: SearchTwitterResult[];
    builders: SearchBuilderResult[];
    hlNames?: SearchHlNameResult[];
    hyperliquidNames?: SearchHyperliquidNameResult[];
}

export interface AssetsData {
    columns: [
        'coin',
        'positionCount',
        'positionCountLong',
        'totalPositionValue',
        'totalPositionValueLong',
    ];
    data: [string, number, number, number, number];
}

export interface AssetsActiveResponse {
    coins: AssetsData;
    coins1HourAgo: AssetsData;
}

export interface PerpsAssetsDataCoins {
    [key: string]: {
        positionCount: number;
        positionCountLong: number;
        totalPositionValue: number;
        totalPositionValueLong: number;
    };
}

export interface PerpsAssetsData {
    coins: PerpsAssetsDataCoins;
    coins1HourAgo: PerpsAssetsDataCoins;
}

export interface PerpsBreakdownBySize {
    bias: number;
    maxSize: number;
    minSize: number;
    pastPositionCount: number;
    pastTotalPositionValue: number;
    positionCount: number;
    size: string;
    sizeSegmentId: number;
    totalPositionValue: number;
    totalPositionValueLong: number;
    valueCloseToLiquidation: number;
}

export interface BreakdownBySizeResponse {
    coin: string;
    createdAt: string;
    breakdownBySize: PerpsBreakdownBySize[];
}

export interface PerpsBreakdownByCohorts {
    bias: number;
    pastPositionCount: number;
    pastTotalPositionValue: number;
    positionCount: number;
    segment: {
        category: 'size' | 'pnl';
        criteria: { minSize?: number; maxSize?: number; maxPnl?: number; minPnl?: number };
        id: number;
        name: string;
    };
    timestamp: string;
    totalPositionValue: number;
    totalPositionValueLong: number;
    valueCloseToLiquidation: number;
}

export interface BreakdownByCohortResponse {
    cohortMetrics: PerpsBreakdownByCohorts[];
    coin: string;
}

export interface CoinSegmentsResponse {
    coin: string;
    segments: PerpsBreakdownByCohorts[];
}
export type SegmentMetricData = [number, number, number, number, number, string][];

export interface SegmentMetric {
    columns: [
        'positionCount',
        'positionCountLong',
        'totalPositionValue',
        'totalPositionValueLong',
        'bias',
        'timestamp',
    ];
    data: SegmentMetricData;
}

export interface SegmentMetricsData {
    metrics: SegmentMetric;
    segment: {
        category: 'size' | 'pnl';
        criteria: { minSize: number; maxSize: number };
        id: SegmentId;
        name: string;
    };
}

export type PositionMetricsData = [string, number, number, number, number][];

export interface PositionsMetric {
    columns: [
        'timestamp',
        'positionCount',
        'positionCountLong',
        'totalPositionValue',
        'totalPositionValueLong',
    ];
    data: PositionMetricsData;
}

export interface PositionMetricsResponse {
    coin: string;
    metrics: PositionsMetric;
}

export interface SegmentMetricsResponse {
    coin: string;
    data: SegmentMetricsData[];
}

export interface StatsMetricsData {
    columns: [
        'timestamp',
        'totalOpenInterest',
        'totalOpenPositions',
        'perpEquity',
        'countInProfit',
        'perpMarginEquity',
    ];
    data: [string, number, number, number, number, number][];
}

export interface StatsMetricsData24HoursAgo {
    columns: [
        'totalOpenInterest',
        'totalOpenPositions',
        'perpEquity',
        'countInProfit',
        'perpMarginEquity',
    ];
    data: [number, number, number, number, number];
}

export interface StatsMetrics {
    athData: {
        totalOpenInterest: number;
        totalOpenPositions: number;
    };
    data: StatsMetricsData;
    data24HoursAgo: StatsMetricsData24HoursAgo;
    /** Set on the client: the row where perp equity switches to perp margin equity. */
    marginSwitchTimestamp?: string;
}

export interface StatsExposeRatioBucket {
    avgWalletEquity: number;
    maxRatio: number;
    medianExposureRatio: number;
    minRatio: number | null;
    perpEquity: number;
    perpMarginEquity: number;
    avgWalletMarginEquity: number;
    ratioBucketId: number;
    walletsCount: number;
    totalOpenPositionValue: number;
}

export interface StatsExposeRatio {
    buckets: StatsExposeRatioBucket[];
    totalPerpWalletEquity: number;
    totalPerpWalletMarginEquity: number;
}

type MetricByHypeTotalColumnKey =
    | 'countHolders'
    | 'countAbove10Holders'
    | 'countAbove100Holders'
    | 'countAbove1kHolders'
    | 'countAbove10kHolders'
    | 'countAbove100kHolders'
    | 'countAbove1mHolders';

type MetricByHypeHistoryColumnKey =
    | 'timestamp'
    | 'countHolders'
    | 'countAbove10Holders'
    | 'countAbove100Holders'
    | 'countAbove1kHolders'
    | 'countAbove10kHolders'
    | 'countAbove100kHolders'
    | 'countAbove1mHolders';

export interface StatsMetricByHype {
    athData: {
        column: MetricByHypeTotalColumnKey[];
        data: number[];
    };
    data24HoursAgo: {
        column: MetricByHypeTotalColumnKey[];
        data: number[];
    };
    history: {
        column: MetricByHypeHistoryColumnKey[];
        data: (number | string)[][];
    };
}

type ActivePerpTradersColumnKey = 'timestamp' | 'count';

export interface StatsActivePerpTraders {
    count24HoursAgo: number;
    countATH: number;
    history: {
        columns: ActivePerpTradersColumnKey[];
        data: (number | string)[][];
    };
}

type TotalWalletsOnHLTotalColumnKey =
    | 'count'
    | 'countAbove0Value'
    | 'countAbove100Value'
    | 'countAbove1kValue'
    | 'countAbove10kValue'
    | 'countAbove100kValue'
    | 'countAbove1mValue';

type TotalWalletsOnHLHistoryColumnKey =
    | 'timestamp'
    | 'count'
    | 'countAbove0Value'
    | 'countAbove100Value'
    | 'countAbove1kValue'
    | 'countAbove10kValue'
    | 'countAbove100kValue'
    | 'countAbove1mValue';

export interface StatsTotalWalletsOnHL {
    data24HoursAgo: {
        columns: TotalWalletsOnHLTotalColumnKey[];
        data: number[];
    };
    history: {
        columns: TotalWalletsOnHLHistoryColumnKey[];
        data: (string | number)[][];
    };
}

type WalletCreationRateColumnKey = 'timestamp' | 'count';

export interface StatsWalletCreationRate {
    accountsCount24HoursAgo: number | null;
    accountsCountLive: number | null;
    historyDaily: {
        column: WalletCreationRateColumnKey[];
        data: (string | number)[][];
    };
    historyHourly: {
        column: WalletCreationRateColumnKey[];
        data: (string | number)[][];
    };
    historyWeekly: {
        column: WalletCreationRateColumnKey[];
        data: (string | number)[][];
    };
}

type TotalWalletsEquityTotalColumnKey =
    | 'totalWalletsEquity'
    | 'perpWalletsEquity'
    | 'spotWalletsEquity'
    | 'stakingWalletsEquity'
    | 'vaultWalletsEquity'
    | 'perpMarginWalletsEquity';

type TotalWalletsEquityHistoryColumnKey =
    | 'timestamp'
    | 'totalWalletsEquity'
    | 'perpWalletsEquity'
    | 'spotWalletsEquity'
    | 'stakingWalletsEquity'
    | 'vaultWalletsEquity'
    | 'perpMarginWalletsEquity';

export interface StartTotalWalletsEquity {
    athData: {
        columns: TotalWalletsEquityTotalColumnKey[];
        data: number[];
    };
    data24HoursAgo: {
        columns: TotalWalletsEquityTotalColumnKey[];
        data: number[];
    };
    history: {
        columns: TotalWalletsEquityHistoryColumnKey[];
        data: (number | string)[][];
    };
    /** Set on the client: the row where perp equity switches to perp margin equity. */
    marginSwitchTimestamp?: string;
}

export interface EquityDistributionBucket {
    bucketId: number;
    equity: number;
    maxValue: number;
    minValue: number;
    walletsCount: number;
}

export interface StatsEquityDistributionBuckets {
    buckets: EquityDistributionBucket[];
    totalEquity: number;
    totalWalletsCount: number;
}

export interface StatsDailyVolume {
    perpVolume24HoursAgo: number | null;
    history: {
        columns: string[];
        data: (string | number)[][];
    };
}

export enum WALLET_TRANSFERS_TYPE {
    DEPOSIT = 'deposit',
    WITHDRAW = 'withdraw',
    REWARDS_CLAIM = 'rewardsClaim',
    SPOT_TRANSFER = 'spotTransfer',
    SUBACCOUNT_TRANSFER = 'subAccountTransfer',
    ACCOUNT_CLASS_TRANSFER = 'accountClassTransfer',
    VAULT_DEPOSIT = 'vaultDeposit',
    VAULT_WITHDRAW = 'vaultWithdraw',
    VAULT_CREATE = 'vaultCreate',
    VAULT_DISTRIBUTION = 'vaultDistribution',
    INTERNAL_TRANSFER = 'internalTransfer',
    C_STACKING_TRANSFER = 'cStakingTransfer',
    SPOT_GENESIS = 'spotGenesis',
    SEND = 'send',
}

export enum DEX {
    VNTL = 'vntl',
    FLX = 'flx',
    XYZ = 'xyz',
    HYNA = 'hyna',
    KM = 'km',
    CASH = 'cash',
    PARA = 'para',
    IO = 'io',
    MKTS = 'mkts',
}

export const DEX_COINS_MAP = {
    [DEX.VNTL]: 'USDH (vntl)',
    [DEX.FLX]: 'USDH (flx)',
    [DEX.XYZ]: 'USDC (xyz)',
    [DEX.HYNA]: 'USDE (hyna)',
    [DEX.KM]: 'USDH (km)',
    [DEX.CASH]: 'USDT (cash)',
    [DEX.PARA]: 'USDC (para)',
    [DEX.IO]: 'USDC (io)',
    [DEX.MKTS]: 'USDC (mkts)',
};

export interface AlertProfile {
    address: string;
    cmmId: string | number | null;
    displayName: string | null;
    showName?: ShowName | null;
    earliestActivityAt: string;
    emoji: string | null;
    favoriteCount: number;
    mid: string | number | null;
    perpPnl: number | null;
    segments: number[];
    totalEquity: number;
    vault: string | number | null;
    verified: boolean;
    xUserId: string | number | null;
}

export interface Alert {
    enabled: boolean;
    name: string;
    trigger: any;
    type: string;
    id: number;
    mid: number;
    createdAt: string;
    updatedAt: string;
    profile?: AlertProfile;
}
export interface AlertsResponse {
    items: Alert[];
    totalCount: number;
}

export interface CreateAlertRequest {
    enabled: boolean;
    name: string;
    trigger: any;
}

export interface AlertsQuotaResponse {
    maxAlerts: number;
    notificationsPerDay: number;
    usedAlerts: number;
}

export interface AlertsStatsResponse {
    totalActiveAlerts: number;
    triggeredToday: number;
}

export enum BASED_CONNECTION_STAGE {
    NON_REFERRED = 'notReferred',
    IN_PROGRESS = 'inProgress',
    UNLOCKED = 'unlocked',
}

export interface CandleChartSettings {
    openClose: boolean;
    mfe: boolean;
    fills: boolean;
    avgEntryLine: boolean;
}

export interface CandleChartSettingsType {
    [key: number]: CandleChartSettings;
}

export enum HL_CONNECTION_STAGE {
    NON_REFERRED = 'notReferred',
    IN_PROGRESS = 'inProgress',
    UNLOCKED = 'unlocked',
}

export enum WalletUserAbstraction {
    PORTFOLIO_MARGIN = 'portfolioMargin',
    DEX_ABSTRACTION = 'dexAbstraction',
    DISABLED = 'disabled',
    UNIFIED_ACCOUNT = 'unifiedAccount',
    DEFAULT = 'default',
}

export const WalletUserAbstractionLabels: Record<WalletUserAbstraction, string> = {
    [WalletUserAbstraction.PORTFOLIO_MARGIN]: 'Portfolio',
    [WalletUserAbstraction.DEX_ABSTRACTION]: 'Dex Abstraction',
    [WalletUserAbstraction.DISABLED]: 'Disabled',
    [WalletUserAbstraction.UNIFIED_ACCOUNT]: 'Unified Account',
    [WalletUserAbstraction.DEFAULT]: 'Standard',
};

export interface FavoriteCoin {
    coin: string;
    type: 'perp';
}
